import React from 'react';
import { HStack, Text, VStack } from '@chakra-ui/react';

export const AddLiquidityTitle = () => {
  return (
    <HStack mb="12px" mt={5} w="100%">
      <VStack>
        <Text
          fontSize="16px"
          fontWeight={400}
          lineHeight="20px"
          color="whiteOpacity.50"
          textAlign="left"
          whiteSpace="nowrap"
        >
          V4 (concentrated liquidity)
        </Text>
      </VStack>
    </HStack>
  );
};
